let env = {};

env.baseURL = 'https://api.versive.com.br/api/v1/';
env.normalURL = 'https://api.versive.com.br/';
env.domainDev = true

export default env



// WEBPACK FOOTER //
// ./src/config/env.js